import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Table } from "react-bootstrap";
// import * as R from "../../css/PersonalSellingRequest/requestForm";
import * as R from "../../../../../css/PersonalSellingRequest/requestForm";
import { DaumPostcode } from "../../../../../utils/DaumPostCode";
import moment from "moment";
import getUserInfo from "../../../../../utils/hooks/getUserInfo";
import { headerText } from "../../../../../App";
import { useAtom } from "jotai";
import { BtnYellow } from "../../../../../css/components/button/buttonYellow";
import { postSaleInsCSell } from "../../../../../api/sale";
import { toast } from "wc-toast";
import { useNavigate } from "react-router-dom";
import CommonRegistration from "../registration-information/CommonRegistration";
import { postNumbaUpdCSellCBuy } from "../../../../../api/mypage";

// 주선번호 매매 판매요청
export const LicenseBuyingInfo = ({ buyReqData }) => {
  return (
    <div className="FormDIv">
      <R.FormDetails_Heading>매물정보</R.FormDetails_Heading>
      <R.FormDetails_Div>
        {/* desktop table */}
        <div className="d-none d-md-block">
          <Table bordered responsive>
            <tbody>
              <tr>
                <R.FormTable_Th width={"20%"}>No.</R.FormTable_Th>
                <td className="paddingLeft" colSpan={3}>{buyReqData?.target_seq}</td>
              </tr>
              <tr>
                <R.FormTable_Th>유형</R.FormTable_Th>
                <td className="paddingLeft" colSpan={3}>
                  {buyReqData?.type === 2104 && "주선번호 매매"}
                </td>
              </tr>
              <tr>
                <R.FormTable_Th>구매자 지역</R.FormTable_Th>
                <td className="paddingLeft">{buyReqData?.region_nm}</td>
                <R.FormTable_Th>구매금액</R.FormTable_Th>
                <td className="paddingLeft">
                  <R.Table_Link style={{ color: "#F14B63" }}>
                    {buyReqData?.price?.toLocaleString()}
                  </R.Table_Link>
                  &nbsp; 만원
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        {/* mobile table */}
        <div className="d-block d-md-none">
          <Table bordered responsive className="table-form">
            <tbody>
              <tr>
                <R.FormTable_Th>No.</R.FormTable_Th>
                <td>{buyReqData?.target_seq}</td>
              </tr>
              <tr>
                <R.FormTable_Th>유형</R.FormTable_Th>
                <td> {buyReqData?.type === 2104 && "주선번호 매매"}</td>
              </tr>
              <tr>
                <R.FormTable_Th>구매자 지역</R.FormTable_Th>
                <td>{buyReqData?.region_nm}</td>
              </tr>
              <tr>
                <R.FormTable_Th>구매금액</R.FormTable_Th>
                <td>
                  <R.Table_Link style={{ color: "#F14B63" }}>
                    {buyReqData?.price?.toLocaleString()}
                  </R.Table_Link>
                  &nbsp; 만원
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </R.FormDetails_Div>
    </div>
  );
};

export const LicenseRequestForm = ({ subActiveTab, buyingData, isEdit }) => {
  // const [modalShow, setModalShow] = useState(false);
  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);
  const [buyReqData, setBuyReqData] = useState({});
  const [userTypeCd, setUserTypeCd] = useState(0);
  const navigate = useNavigate();
  //   type 2101 : 개인 매매

  // 신청
  const callInsCBuy = async (data) => {
    const msg = validateSellReq(buyReqData);
    if (msg) {
      return toast.error(msg);
    }

    try {
      const response = await postSaleInsCSell({
        ...data,
      });
      // if (response?.code === 1000) {
      //   navigate("/cselling-complete-request", {
      //     state: { data: { ...data, type: 2104 } },
      //     replace: true,
      //   });
      // } else {
      //   toast.error("등록실패");
      //   navigate(-1);
      // }
      switch (response?.code) {
        case 1000:
          navigate("/cselling-complete-request", {
            state: data,
            replace: true,
          });
          break;
        case -19:
          toast.error("이미 진행중인 매물입니다.");
          break;
        case -22:
          toast.error("본인의 매물입니다.");
          break;
        case -23:
          toast.error("이미 신청한 매물입니다.");
          break;
        default:
          toast.error("거래신청이 되지 않았습니다. 다시 시도해주세요.");
          navigate(-1);
          break;
      }
    } catch (err) {
      switch (err.code) {
        case -19:
          toast.error("이미 진행중인 매물입니다.");
          break;
        case -22:
          toast.error("본인의 매물입니다.");
          break;
        case -23:
          toast.error("이미 신청한 매물입니다.");
          break;
        default:
          toast.error("거래신청이 되지 않았습니다. 다시 시도해주세요.");
          navigate(-1);
          break;
      }
    }
  };

  // 수정
  const editCallInsCBuy = async (data) => {
    try {
      const response = await postNumbaUpdCSellCBuy(data);
      if (response?.code === 1000) {
        toast.success("수정되었습니다.");
      } else {
        toast.error("수정이 실패하였습니다.");
      }
    } catch (err) {
      toast.error("수정이 실패하였습니다.");
    }
    navigate(-1);
  };

  useEffect(() => {
    setHeaderTextAtom("삽니다\u00A0\u00A0거래신청");
  }, []);

  useEffect(() => {
    setBuyReqData({ ...buyingData });
  }, [buyingData]);

  const validateSellReq = (buyReqData) => {
    if (userTypeCd === 202) {
      if (!buyReqData?.corp_nm?.trim() || buyReqData.corp_nm === "" || buyReqData.corp_nm === undefined) {
        return "법인명을 확인해 주세요.";
      }
    }
    if (!buyReqData?.user_nm?.trim() || buyReqData.user_nm === "" || buyReqData.user_nm === undefined) {
      return `${userTypeCd === 202 ? "담당자" : "신청자"
        } 이름을 확인해 주세요.`;
    }
    if (!buyReqData.phone || buyReqData.phone === "" || buyReqData.phone === undefined) {
      return `${userTypeCd === 202 ? "담당자" : "신청자"
        } 휴대폰번호를 확인해 주세요.`;
    }
    if (buyReqData?.phone?.length < 10) {
      return "휴대폰 번호가 올바르지 않습니다.";
    }
    if (!buyReqData.addr1 || buyReqData.addr1 === "" || buyReqData.addr1 === undefined) {
      return "주소를 확인해 주세요.";
    }
    if (!buyReqData.zip || buyReqData.zip === "" || buyReqData.zip === undefined) {
      return "우편번호를 확인해 주세요.";
    }
    // if (!buyReqData.addr2 || buyReqData.addr2 === "" || buyReqData.addr2 === undefined) {
    //   return "상세주소를 확인해 주세요.";
    // }
  };

  return (
    <>
      <div className="requestFormMain-container">
        <Container className="p-0">
          <Row>
            <Col md={12}>
              <div className="pc_view">
                <R.FormHeading_div>
                  <R.Form_Heading>거래신청</R.Form_Heading>
                </R.FormHeading_div>
              </div>
              <LicenseBuyingInfo buyReqData={buyReqData} />
              <CommonRegistration
                buyReqData={buyReqData}
                setUserTypeCd={setUserTypeCd}
                setBuyReqData={setBuyReqData}
                buyingData={buyingData}
              />
              <div className="mt-3 text-center">
                <BtnYellow
                  width="360px"
                  height="60px"
                  onClick={() => {
                    if (isEdit) {
                      editCallInsCBuy(buyReqData);
                    } else {
                      callInsCBuy(buyReqData);
                    }
                  }}
                >
                  {isEdit ? "수정하기" : "신청하기"}
                </BtnYellow>
              </div>
            </Col>
          </Row>
        </Container>
        {/* <TablePopup show={modalShow} onHide={() => setModalShow(false)} /> */}
      </div>
    </>
  );
};

// export default PersonalRequestForm;
